module.exports = __webpack_public_path__ + "img/passport-control.a98dfc31.png";